var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:flex",attrs:{"id":"desk"}},[_c('div',{staticClass:"flex flex-col flex-1 my-0 mx-auto max-w-6xl"},[_c('div',{staticClass:"pb-14 lg:pb-0 lg:px-10 lg:pt-12 lg:flex"},[_c('desk-tasks'),_c('desk-notes')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }